import { LanguageLocale, LanguageMessagesKeys } from '../types/LanguageLocale'
import appLocalData from 'react-intl/locale-data/de'

const messages: LanguageMessagesKeys = { 

  // Common
  'side-effect.successful-title': 'Alles in Ordnung',
  'side-effect.successful-message': 'Die Daten wurden korrekt gespeichert',
  'side-effect.internal-error-title': 'Ein Fehler ist aufgetreten',
  'side-effect.internal-error-message': 'Bitte versuchen Sie es später noch einmal oder überprüfen Sie Ihre Internetverbindung',

  'monday-sshort-label': 'Mo',
  'tuesday-sshort-label': 'Di',
  'wednesday-sshort-label': 'Mi',
  'thursday-sshort-label': 'Do',
  'friday-sshort-label': 'Fr',
  'saturday-sshort-label': 'Sa',
  'sunday-sshort-label': 'So',

  'monday-short-label': 'Mon',
  'tuesday-short-label': 'Die',
  'wednesday-short-label': 'Mit',
  'thursday-short-label': 'Don',
  'friday-short-label': 'Fre',
  'saturday-short-label': 'Sam',
  'sunday-short-label': 'Son',

  'monday-label': 'Montag',
  'tuesday-label': 'Dienstag ',
  'wednesday-label': 'Mittwoch',
  'thursday-label': 'Donnerstag',
  'friday-label': 'Freitag',
  'saturday-label': 'Samstag',
  'sunday-label': 'Sonntag ',

  'january-label': 'Januar',
  'february-label': 'Februar',
  'march-label': 'März',
  'april-label': 'April',
  'may-label': 'Mai',
  'june-label': 'Juni',
  'july-label': 'Juli ',
  'august-label': 'August ',
  'september-label': 'September',
  'october-label': 'Oktober',
  'november-label': 'November',
  'december-label': 'Dezember ',

  'interval-name-year': 'Jahr',
  'interval-name-month': 'Monat',
  'interval-name-week': 'Woche',
  'interval-name-day': 'Tag',
  'interval-name-years': 'Jahre',
  'interval-name-months': 'Monate',
  'interval-name-weeks': 'Wochen',
  'interval-name-days': 'Tage',

  'select-input.no-options-label': 'Keine Optionen',
  'filter-input.label': 'Filter:',

  'no-data.label': 'Keine Daten zu sehen. Filter oder das ausgewählte Datum ändern.',
  'no-data.label-mid': 'Es werden keine Daten angezeigt. Ändern Sie das ausgewählte Datum.',
  'no-data.label-short': 'Es werden keine Daten angezeigt.',
  'empty-list-label': 'Leere Liste.',
  'overlay.empty-device-label': 'Es wurden noch keine Geräte zu diesem Profil hinzugefügt.',
  'overlay.empty-profiles-label': 'Es wurde noch kein Profil hinzugefügt.',
  'overlay.empty-device.add-device-label': 'Gerät hinzufügen',

  'confirmation-modal.cancel-button': 'Abbrechen ',
  'confirmation-modal.confirm-button': 'Bestätigen ',
  'confirmation-modal.button-yes': 'Ja',
  'confirmation-modal.button-no': 'Nein',

  // Date Picker
  'date-picker.select-date-label': 'Datum auswählen',

  // Date Filter
  'date-filter.select-label': 'Angebot auswählen',
  'date-filter.this-month': 'Dieser Monat',
  'date-filter.this.week': 'Diese Woche',
  'date-filter.this.day': '24h',
  'date-filter.this.custom': 'Tag auswählen',
  'date-filter.from-label': 'Von: ',
  'date-filter.to-label': 'Bis: ',

  // Time Picker
  'time-picker.unlimied-label': 'Unbegrenzt',
  'time-picker.time-format': '{h}h {m}min',
  'time-picker.time-format-min': '{m} min',
  'time-picker.time-format-hour': '{h}h',

  'time-picker.add-bonus-title': 'Add time bonus only for today',
  'time-picker.no-bonus' : 'No bonus',
  'time-picker.bonus': 'Bonus',
  'time-picker.add-bonus-button-set': 'Set bonus',
  'time-picker.add-bonus-button-cancel' : 'Cancel',
  

  // Profile image picker
  'profile-image-picker.date-range-label': '',
  'profile-image-picker.girl-label': 'Datumsbereich',
  'profile-image-picker.boy-label': 'Mädchen',

  // Profile List
  'profile-list.remove-device-label': 'Gerät entfernen',
  'profile-list.move-device-label': 'Gerät in ein anderes Profil verschieben',
  'profile-list.add-device-label': 'Gerät hinzufügen',

  'profile-list.add-profile-label': 'Profil hinzufügen',
  'profile-list.edit-profile-label': 'Profil bearbeiten',
  'profile-list.add-devices-label': 'Neues Gerät hinzufügen',
  'profile-list.remove-profile-label': 'Profil entfernen',
  'profile-list.remove-profile-disabled-tooltip': 'Um Ihr Profil zu löschen, müssen Sie zunächst alle mit dem Profil verbundenen Geräte entfernen.',
  'profile-list.title': 'Liste der Profile',

  // Profile Form
  'profile-form.full-name-label': 'Name',
  'profile-form.month-of-birth-label': 'Monat der Geburt',
  'profile-form.year-of-birth-label': 'Jahr der Geburt',

  // Profile Form
  'profile-form-modal.create.skip-button': 'Abbrechen',
  'profile-form-modal.create.submit-button': 'PROFIL HINZUFÜGEN',
  'profile-form-modal.create.title': 'Kinderprofil hinzufügen',
  'profile-form-modal.edit.skip-button': 'Abbrechen',
  'profile-form-modal.edit.submit-button': 'SPEICHERN',
  'profile-form-modal.edit.title': 'Profil des Kindes bearbeiten',
  'profile-form-modal.max-profiles-error': 'Profil-Limit erreicht',

  // Profile Move Device Form
  'profile-move-device-modal.title': 'Gerät in ein anderes Profil verschieben',
  'profile-move-device-modal.cancel-button': 'Abbrechen',
  'profile-move-device-modal.submit-button': 'Speichern',
  'profile-move-device-modal.select-profile-label': 'Profil auswählen',

  // CallLog
  'call-log.duration-label': 'Dauer des Gesprächs:',
  'call-log.seconds-label': '',

  // Create Profile Page
  'create-profile-page.submit-button': 'PROFIL HINZUFÜGEN',
  'create-profile-page.skip-button': 'Abbrechen',
  'create-profile-page.title': 'Profil des Kindes hinzufügen',
  'create-profile-page.description': 'Wer wird überwacht',

  // Add device page
  'add-device-page.close-button': 'CLOSE',
  'add-device-page.description': 'Wählen Sie den Gerätetyp für die Installation der App',
  'add-device-page.title': 'Installationsanleitung',
  'add-device-page.check': 'Handbuch prüfen',
  'add-device-page.mobile-title': 'Android-Smartphone oder -Tablet',
  'add-device-page.mobile-description': 'Android Version 6 oder höher',
  'add-device-page.desktop-title': 'Windows-Desktop oder -Laptop',
  'add-device-page.desktop-description': 'Windows Version 7 oder höher',


  // Purchase Page
  'purchase-page.skip-label': 'Zum Dashboard gehen',
  'purchase-page.title': 'Wählen Sie den besten Plan',
  'purchase-page.title.features': 'Alle Tarife bieten die folgenden Funktionen',
  'purchase-page.title.reviews': 'Warum unsere Nutzer uns lieben',
  'purchase-page.subtitle': 'Wenn das Programm nicht Ihren Erwartungen entspricht, erstatten wir Ihnen die Zahlung zurück',
  'purchase-page.plan-highlight': 'Bester Wert',
  'purchase-page.monthly': 'monatlich',
  'purchase-page.select': 'Wählen Sie',
  'purchase-page.close': 'Schließen Sie',
  'purchase-page.money-back.title': 'Risikofrei',
  'purchase-page.money-back.desc': 'Wenn Sie nicht zufrieden sind, erhalten Sie Ihr Geld zurück.',
  'purchase-page.header.check-1': 'Beste App zur Kindersicherung',
  'purchase-page.header.check-2': 'Setzen Sie Zeitlimits für Spiele, YouTube und Websites',
  'purchase-page.header.check-3': 'Hunderttausende zufriedene Kunden',
  'purchase-page.plan.year': 'Jahr',
  'purchase-page.plan.optimal': 'Bester Wert',


  'purchase-page.modal.2y-header': 'Sonderangebot!',
  'purchase-page.modal.2y-sub-header': '',
  'purchase-page.modal.2y-sub-header2': '',
  'purchase-page.modal.protect-plan-devices': 'Schützen Sie bis zu {Geräte} Geräte',
  'purchase-page.modal.upgrade': 'Wählen Sie den Rabatt',
  'purchase-page.modal.no-thanks': 'Mit dem 1-Jahres-Plan fortfahren',


  'purchase-plan.features.title.feature_1': 'Zeitlimit für Apps und Spiele',
  'purchase-plan.features.title.feature_2': 'Website-Filterung',
  'purchase-plan.features.title.feature_3': 'Blockieren von Apps, Spielen und Websites',
  'purchase-plan.features.title.feature_4': 'Youtube-Überwachung',
  'purchase-plan.features.title.feature_5': 'Live-Fernüberwachung des Bildschirms',
  'purchase-plan.features.title.feature_6': 'Fernzugriff',
  'purchase-plan.features.title.feature_7': 'Detaillierte Berichte',
  'purchase-plan.features.title.feature_8': 'Standortbestimmung (nur Telefon)',
  'purchase-plan.features.title.feature_9': 'Nachrichten und Anrufe prüfen',
  'purchase-plan.features.title.feature_10': 'Vorrangige technische Unterstützung',

  'purchase-plan.features.desc.feature_1': 'Setzen Sie Zeitlimits für Apps, Spiele und Internetzugang. Legen Sie außerdem fest, zu welchen Zeiten Ihr Kind darauf zugreifen darf',
  'purchase-plan.features.desc.feature_2': 'Alle unangemessenen Websites werden blockiert. Das Programm verwendet einen Algorithmus, der den Inhalt der Website auf unangemessenes Material analysiert. Außerdem sammelt es Informationen aus einer riesigen Datenbank mit ungeeigneten Websites und Wörtern, die beide regelmäßig aktualisiert werden.',
  'purchase-plan.features.desc.feature_3': 'Blockieren Sie Apps und Websites, die einen negativen Einfluss auf Ihre Kinder haben könnten. Außerdem muss jedes neu installierte Spiel von Ihnen genehmigt werden.',
  'purchase-plan.features.desc.feature_4': 'In the dashboard, monitor all videos your child watches on YouTube. Block any video or completely block access to video services.',
  'purchase-plan.features.desc.feature_5': 'Greifen Sie aus der Ferne auf einen Live-Feed des Bildschirms Ihres Kindes zu und überprüfen Sie seine Aktivitäten während des Tages. So können Sie die Inhalte, auf die Ihr Kind zugreift, genau im Auge behalten.',
  'purchase-plan.features.desc.feature_6': 'Sobald Sie sich angemeldet haben, können Sie von überall und von jedem Gerät aus auf das Dashboard für Eltern zugreifen. Im Dashboard können Sie die Einstellungen anpassen, die Geräte der Kinder überwachen und Zeitlimits festlegen.',
  'purchase-plan.features.desc.feature_7': 'Im elterlichen Dashboard können Sie ganz einfach die Aktivitäten Ihres Kindes am Computer oder Telefon überwachen, sehen, wie viel Zeit es am Bildschirm verbracht hat, welche Websites es besucht hat, und vieles mehr.',
  'purchase-plan.features.desc.feature_8': "Check your child's current location and past locations on the map. See exactly where your child was on any given day or at a certain time.",
  'purchase-plan.features.desc.feature_9': 'Sie können die gesendeten und empfangenen Nachrichten, Anrufe und gespeicherten Kontakte Ihres Kindes ganz einfach über das Elternbedienfeld überprüfen.',
  'purchase-plan.features.desc.feature_10': 'Sollten Sie Hilfe benötigen, sind wir immer für Sie da. Es gibt auch viele Videoanleitungen, die Sie bei der Verwendung von {app} unterstützen.',



  'purchase-plan.raitings.desc.name_1': 'Sophia',
  'purchase-plan.raitings.desc.name_2': 'Olivia',
  'purchase-plan.raitings.desc.name_3': 'Mateo',
  'purchase-plan.raitings.desc.name_4': 'Lucas',
  'purchase-plan.raitings.desc.name_5': 'Emma',
  'purchase-plan.raitings.desc.name_6': 'Emma',

  'purchase-plan.raitings.desc.raiting_1': 'Sehr effizient! Schützt mein Kind vollständig vor schädlichen Internetinhalten.',
  'purchase-plan.raitings.desc.raiting_2': 'Genau das, wonach ich gesucht habe! Ich habe ein tägliches Limit von einer Stunde für den Internetzugang meiner Töchter festgelegt und Avosmart kümmert sich für mich darum.',
  'purchase-plan.raitings.desc.raiting_3': 'Ich empfehle Avosmart, weil es eine Vielzahl von Funktionen hat. Meine Kinder sind bei der Nutzung des Internets geschützt und ich kann kontrollieren, wie viel Zeit sie mit Spielen usw. verbringen.',
  'purchase-plan.raitings.desc.raiting_4': 'Für meine Frau und mich war es wichtig, ein Auge auf die Social-Media-Gewohnheiten unserer Tochter zu haben. Avosmart hilft uns, das digitale und das reale Leben unserer Tochter im Gleichgewicht zu halten.',
  'purchase-plan.raitings.desc.raiting_5': 'Mein Sohn hat früher zu viel Zeit im Internet verbracht und dabei einen Laptop, ein Tablet usw. benutzt. Dank der von Avosmart bereitgestellten Berichte weiß ich genau, welche Websites mein Sohn besucht und wie lange.',
  'purchase-plan.raitings.desc.raiting_6': 'Jetzt kann ich jederzeit den aktuellen Standort meines Sohnes überprüfen. Ein hervorragender Service!',


  'account-settings-page.title': 'Kontoeinstellungen',
  'account-settings-page.automatic-update': 'Automatische Updates der Windows-Anwendung',
  'account-settings-page.timezone': 'Zeitzone : ',
  'account-settings-page.send-reports': 'Tägliche Aktivitätsberichte senden',


  'plans-info-page.title': 'Informationen zum Abonnement',
  'plans-info-page.plan': ' Plan:',
  'plans-info-page.max-devices': 'Maximale Anzahl von Geräten:',
  'plans-info-page.valid-till': 'Verfallsdatum:',

  'plans-info-page.your-plan': 'Ihr Plan:',
  'plans-info-page.subscription-information': 'Informationen zum Abonnement',
  'plans-info-page.subscription-created': 'Abonnement erstellt: ',
  'plans-info-page.subscription-current-period': 'Aktuelle Abonnementdauer: ',
  'plans-info-page.subscription-renews-on': 'Ihr Abonnement verlängert sich am ',
  'plans-info-page.subscription-cancel-renewal': 'Erneuerung abbrechen',
  'plans-info-page.subscription-not-renewed': 'Ihr Abonnement wird am Ende des aktuellen Zeitraums NICHT erneuert',
  'plans-info-page.subscription-enable-renewal': 'Erneuerung einschalten',
  'plans-info-page.subscription-price': 'Preis des Abonnements: ',
  'plans-info-page.subscription-price-amount': '{Betrag} alle {Zeitraum}',

  'plans-info-page.upgrade-plan': 'Aktualisieren Sie Ihren Plan',
  'plans-info-page.extend-lic': 'Ihren Tarif verlängern',
  'plans-info-page.subscriptions-portal': 'Verwalten Sie Ihre Zahlungsarten',
  'plans-info-page.recent-payments': 'Letzte Transaktionen',
  'plans-info-page.date-of-payment': 'Datum der Transaktion:',
  'plans-info-page.transaction-status': 'Transaktionsstatus:',
  'plans-info-page.no-recent-payments': 'Keine letzten Transaktionen',
  'plans-info-page.btn-close': 'Schließen',
  'plans-info-page.plan-devices': 'bis zu {Geräte} Geräte',
  'plans-info-page.plan-devices-types': 'Computer/Tablets/Telefone',


  'upgrade-page.title': 'Upgrade the plan',
  'upgrade-page.devices': 'Devices: ',
  'upgrade-page.valid-till': 'Your plan is valid until: ',
  'upgrade-page.confirm-upgrade': 'Your plan will be upgraded, you will be charged {amount}',
  'upgrade-page.pay-now': 'Pay now {amount}',
  'upgrade-page.pay-then': 'Then {amount} every {period}',

  // Purchase Checkout (Stripe ver)

  'purchase-checkout.buy-subscription': 'Abonnement kaufen',
  'purchase-checkout.up-to-devices': 'Bis zu {Geräte} Geräte',
  'purchase-checkout.subscribtion-price': '{Betrag} alle {Zeitraum}',
  'purchase-checkout.subscribe': 'Abonnieren',
  'purchase-checkout.cancel': 'Abbrechen',


  // Purchase Status Page
  'purchase-status-page.title': 'Kontrolle der Zahlung',
  'purchase-status-page.status-pending': 'Ausstehend',
  'purchase-status-page.status-completed': 'Abgeschlossen',
  'purchase-status-page.status-canceled': 'Storniert',
  'purchase-status-page.status-refund-finalized': 'Rückerstattung abgeschlossen',
  'purchase-status-page.status-wating-for-conf': 'Warten auf Bestätigung',
  'purchase-status-page.status-created': 'Erstellt',
  'purchase-status-page.status-unkown': 'Unbekannt',
  'purchase-status-page.status-error': 'Fehler',
  'purchase-status-pag.back-button': 'Zurück zur Hauptseite',
  'purchase-status-pag.invoice-link': 'Ich möchte eine Mehrwertsteuerrechnung erhalten',

  // Login Page
  'login-page.brandline': 'Einloggen',
  'login-page.brandline2': 'Filterung der Website',
  'login-page.email-label': 'E-Mail Adresse',
  'login-page.login-button': 'ANMELDEN',
  'login-page.password-label': 'Kennwort',
  'login-page.recovery-link': 'Haben Sie Ihr Passwort vergessen?',
  'login-page.invalid-login-error': 'Die E-Mail-Adresse oder das Passwort, das Sie eingegeben haben, ist ungültig.',

  // Register Page
  'register-page.create-account-label': 'Benötigen Sie ein Konto? Erstellen Sie ein neues Konto',
  'register-page.description': 'Erstellen Sie Ihr kostenloses Konto',
  'register-page.email-label': 'E-Mail Adresse',
  'register-page.login-link-label': 'Haben Sie ein Konto? Anmelden',
  'register-page.marketing-checkbox-label': 'Ich bin damit einverstanden, Marketing- und Werbematerial zu erhalten',
  'register-page.password-label': 'Kennwort',
  'register-page.phoneNumber-label': 'Telefon-Nummer',
  'register-page.terms-privacy-checkbox-label': 'Ich stimme den Datenschutzrichtlinien und Nutzungsbedingungen zu',
  'register-page.register-button': 'REGISTRIEREN',
  'register-page.register-success-title': 'Erfolg',
  'register-page.register-success-message': 'Die Anmeldung war erfolgreich. Prüfen Sie Ihre Mailbox, um die E-Mail zu bestätigen.',
  'register-page.register-error-captcha': 'Captcha-Fehler. Versuchen Sie es erneut.',
  'register-page.register-error-already-registered-label': 'Bereits registriert. Versuchen Sie, sich anzumelden oder Ihr Passwort zu erinnern.',
  'register-page.register-error-password-to-short-label': 'Passwort zu kurz.',

  // Forgot Password Page
  'register-page.strong-pass': 'Ihr Passwort ist zu einfach und kann von anderen Personen leicht entschlüsselt werden. Ihr Passwort sollte Groß- und Kleinbuchstaben sowie Zahlen enthalten und mindestens 8 Zeichen lang sein. Sind Sie sicher, dass Sie ein einfaches Passwort verwenden wollen?',
  'forgot-password-page.headline-title': 'Passwort erinnern',
  'forgot-password-page.email-label': 'E-Mail Adresse',
  'forgot-password-page.reset-button': 'PASSWORT ERINNERN',
  'forgot-password-page.login-link-label': 'Zurück zur Anmeldeseite',
  'forgot-password-page.success-title': 'Passwort zurücksetzen',
  'forgot-password-page.success-message': 'In Ihrer Mailbox finden Sie Anweisungen, wie Sie Ihr Passwort zurücksetzen können.',
  'forgot-password-page.email-not-confirmed': 'Ihre E-Mail-Adresse ist nicht verifiziert. Passwort zurücksetzen ist nicht verfügbar.',

  // Update Password Page
  'update-password-page.headline-title': '',
  'update-password-page.warning-title': '',
  'update-password-page.warning-description': 'Das Festlegen eines neuen Passworts führt zum Verlust der zuvor gespeicherten Standortdaten. Die übrigen Daten gehen nicht verloren.',
  'update-password-page.warning-agreement': 'Ich verstehe und akzeptiere den Verlust von Standortdaten.',
  'update-password-page.new-password': 'Neues Passwort:',
  'update-password-page.new-password-retype': 'Wiederholen Sie das neue Passwort:',
  'update-password-page.submit': 'Neues Kennwort festlegen',
  'update-password-page.alert-weak-password': 'Ihr Passwort ist zu einfach und könnte von Unbefugten leicht erraten werden. Das Passwort sollte Großbuchstaben, Kleinbuchstaben und Zahlen enthalten und mindestens 8 Zeichen lang sein. Wollen Sie trotzdem ein einfaches Passwort verwenden?',
  'update-password-page.alert-agreement': 'Die Akzeptanz von Datenverlusten ist erforderlich.',
  'update-password-page.error-message': 'Fehler! Das Setzen eines neuen Passworts ist fehlgeschlagen. ',
  'update-password-page.success-message': 'Neues Passwort gesetzt',
  'update-password-page.unknow-error-message': 'Etwas ist schief gelaufen',
  'update-password-page.error-link': 'Falscher Link',
  'update-password-page.error-posswords-not-equal': 'Passwörter nicht gleich',
  'update-password-page.error-posswords-length': 'Passwörter zu kurz',
  'update-password-page.error-wrong-code': 'Falscher Code',
  'update-password-page.register-success-title': 'Erfolgreich!',
  'update-password-page.register-success-message': 'Neues Passwort gesetzt.',

  // Error Page
  'not-found-page.title': 'Ups... es scheint ein Fehler aufgetreten zu sein!',
  'not-found-page.error-code-text': 'Fehlermeldung',
  'not-found-page.go-back-home-button': 'ZURÜCK ZUM START',

  // Panel Page
  'panel-page.purchase-ending-soon-alert': 'Ihr Plan endet am {Datum}. Bitte erwägen Sie noch heute den Kauf eines Abonnements',
  'panel-page.purchase-demo-alert': 'Sie verwenden derzeit die Testversion.',
  'panel-page.purchase-expired-alert': 'Sie verwenden derzeit eine abgelaufene Testversion. Kaufen Sie ein Abonnement, um fortzufahren',
  'panel-page.purchase-lic-expired-alert': 'Ihr Abonnementplan ist abgelaufen. Kaufen Sie ein Abonnement, um fortzufahren',
  'panel-page.email-alert': 'Sie haben Ihre E-Mail Adresse nicht bestätigt',
  'panel-page.button-email-resend': 'Senden Sie die E-Mail erneut',
  'panel-page.email-alert-resend': ' oder senden Sie die E-Mail noch einmal.',
  'panel-page.email-alert-resend-title': 'Bestätigen Sie',
  'panel-page.email-alert-resend-msg': 'Die E-Mail wurde gesendet!',
  'panel-page.profile-delete-description': 'Sind Sie sicher, dass Sie das ausgewählte Profil löschen möchten?',
  'panel-page.profile-delete-device-description': 'Sind Sie sicher, dass Sie das ausgewählte Gerät löschen möchten? Die Daten gehen verloren.',
  'panel-page.profile-delete-device-second-description': 'Der Schutz des Geräts wird deaktiviert. Sind Sie sicher, dass Sie fortfahren möchten?',

  'panel-page.email-confirmation-overlay-close': 'Schließen',
  'panel-page.email-confirmation-overlay-postpone': 'Später',
  'panel-page.email-confirmation-overlay-resend': 'E-Mail erneut senden',
  'panel-page.email-confirmation-overlay-header': 'Ihre E-Mail Adresse wurde noch nicht verifiziert',
  'panel-page.email-confirmation-overlay-desc': "Sollten Sie sich bei der obigen E-Mail-Adresse geirrt haben, teilen Sie uns dies bitte umgehend mit.  <br> Wenn Sie die E-Mail nicht erhalten haben, klicken Sie bitte auf 'erneut senden' und überprüfen Sie Ihre anderen E-Mail-Ordner (einschließlich Junk/Spam).",

  'panel-page.email-confirmation-code-success-header': 'Danke, dass',
  'panel-page.email-confirmation-code-success-desc': 'E-Mail wurde bestätigt!',
  'panel-page.email-confirmation-code-header': 'Bitte geben Sie den 6-stelligen Bestätigungscode ein, der <br> an Ihre E-Mail Adresse gesendet wurde.',
  'panel-page.email-confirmation-code-error-invalid-code': 'Der angegebene Code ist ungültig',
  'panel-page.email-confirmation-code-error': 'Bei der Überprüfung des Codes ist ein unerwarteter Fehler aufgetreten',

  // Summary Page
  'summary-page.title': 'Dashboard',
  'summary-page.top-apps.title': 'Top-Apps',
  'summary-page.top-blocked.title': 'Top blockiert',
  'summary-page.top-domains.title': 'Am häufigsten besuchte Webseiten',
  'summary-page.top-search.title': 'Top-Suche',
  'summary-page.access-disable': 'Temporäre Deaktivierung',
  'internet-page.access-time-limit-description': 'Legen Sie tägliche Zeitlimits für jedes Gerät fest und bestimmen Sie, wie viele Stunden Internetnutzung erlaubt sind.',
  'internet-page.access-time-limit-set-label': 'Tägliches Limit für den Internetzugang:',
  'disable-access.protection-enabled': 'Schutz ist aktiv',
  'disable-access.protection-disabled-for': 'Der Schutz ist vorübergehend deaktiviert, {time} Minuten übrig',
  'disable-access.device-offline': 'Gerät nicht verfügbar',
  'disable-access.protection-status': 'Schutzstatus',


  // Internet Page
  'internet-page.headline-title': 'Web-Seiten',
  'internet-page.access-time-page-title': 'Zugriffszeit',
  'internet-page.settings-page-title': 'Einstellungen',
  'internet-page.statistics-page-title': 'Statistiken',
  'internet-page.searches-page-title': 'Suchanfragen',

  'internet-page.statistics-page-www-ok': 'Zugelassene Website',
  'internet-page.statistics-page-www-ok-white': 'Sichere Website',
  'internet-page.statistics-page-www-timelimit': 'Aufgrund von Zeitlimits gesperrte Website',
  'internet-page.statistics-page-www-userdef': 'Gesperrte Website, Benutzerdefinitionen',
  'internet-page.statistics-page-www-content': 'Gesperrte Website, unangemessener Inhalt',


  'internet-page.white-black-list-page-title': 'Sichere/gesperrte Websites',
  // Internet Page / Settings page
  'internet-page.settings-page.filters.card-title': 'Filter',
  'internet-page.settings-page.white-list-only-label': 'Erlaubt nur den Zugang zu Websites auf der Liste der sicheren Websites',
  'internet-page.settings-page.block-erotic-label': 'Zugang zu erotischen Websites blockieren',
  'internet-page.settings-page.block-offensive-label': 'Zugriff auf anstößige, aggressive Websites blockieren',
  'internet-page.settings-page.block-file-sites-label': 'Zugriff auf Seiten blockieren, die das Herunterladen von Dateien aus dem Internet ermöglichen',
  'internet-page.settings-page.block-video-label': 'Zugang zu Videoportalen blockieren',
  'internet-page.settings-page.block-social-label': 'Zugang zu sozialen Netzwerken blockieren',
  'internet-page.settings-page.block-doc-label': 'Blockieren des Downloads von Dokumenten',
  'internet-page.settings-page.block-exe-label': 'Blockieren Sie das Herunterladen von Programmen',
  'internet-page.settings-page.excludeYT-label': 'Keine sichere Suche auf YouTube erzwingen',
  'internet-page.settings-page.block-new-apps': 'Neue Anwendungen blockieren',
  'internet-page.settings-page.block-settings': 'Zugang zu den Einstellungen blockieren',
  'internet-page.settings-page.custom-msg.card-tile': 'Nachricht für blockierte Seiten',
  'internet-page.settings-page.custom-msg.custom-msg-on-label': 'Personalisierte Nachricht für blockierte Webseiten verwenden',
  'internet-page.settings-page.save-settings-button-label': 'Einstellungen speichern',
  // Internet Page / Lists / White list
  'internet-page.lists.add-to-list-label': 'Zur Liste hinzufügen:',
  'internet-page.lists.add-button-label': 'hinzufügen',
  'internet-page.lists.remove-button-label': 'Löschen',
  'internet-page.lists.white-list.card-title': 'Sichere Liste',
  'internet-page.lists.black-list.card-title': 'Gesperrte Liste',
  'internet-page.lists.remove-prefix': 'Die eingegebene Adresse beginnt mit "{prefix}", es wird empfohlen, nur den Domänennamen hinzuzufügen. Möchten Sie "{prefix}" aus der Adresse entfernen?',
  // Internet Page /  Statistics
  'internet-page.statistics.visited-pages-card-title': 'Besuchte Seiten',

  'internet-page.searches.searches-pages-card-title': 'Gesuchte Phrasen',

  // Internet Page / Access Time
  'internet-page.access-time.schedule-card-title': 'Zeitplan',
  'internet-page.access-time.schedule-legend-label': 'Legende zum Fahrplan',
  'internet-page.access-time.schedule-internet-available-label': 'Internet verfügbar',
  'internet-page.access-time.schedule-internet-blocked-label': 'Internet gesperrt',

  // Calls And SMS Page
  'calls-text-messages-page.headline-title': 'Anrufe und Textnachrichten (SMS)',

  // Calls and SMS Page / Calls List
  'calls-text-messages-page.calls-list-title': 'Anrufe',
  // Calls And SMS Page / List
  'calls-text-messages-page.sms-list-title': 'Textnachrichten (SMS)',
  // Calls And SMS Page / Contacts
  'calls-text-messages-page.contacts-last-changed-label': 'Letzte Änderung:',
  'calls-text-messages-page.contacts-no-changes-label': 'Leer.',
  'calls-text-messages-page.contacts-phone-label': 'tel.',
  'calls-text-messages-page.contacts-title': 'Kontakte',

  // Localization Page
  'localization-page.headline-title': 'Standort',
  'localization-page.headline-title-off': 'Lokalisierungen, GPS-Verfolgung ist ausgeschaltet',
  'localization-page.map-hours-filter-label': 'Wählen Sie einen Zeitbereich, um den Standortverlauf anzuzeigen',
  'localization-page.gps-tracking-on': 'GPS-Verfolgung aktiviert',
  'localization-page.gps-view-speed': 'Reisegeschwindigkeit anzeigen',
  'localization-page.map-loading-label': 'Karten laden...',
  'localization-page.map-no-data': 'KEINE DATEN',

  'localization-page.one-gps-was-off-since': 'Geräteortungsdienste ausgeschaltet seit {lastOffStr}',
  'localization-page.one-gps-was-off-for': 'Geräteortungsdienste ausgeschaltet seit {elapsedStr}',
  'localization-page.many-gps-was-off-since': 'Geräteortungsdienste ausgeschaltet seit {lastOffStr}',
  'localization-page.many-gps-was-off-for': 'Geräteortungsdienste ausgeschaltet seit {elapsedStr}',


  // Battery Page
  'battery-page.headline-title': 'Batterie',
  'battery-page.chart-description': 'Akkustand',

  // Access Time Page
  'access-time-page.headline-title': 'Zugriffszeit',
  'access-time-page.nav-access-time-label-applications': 'Anwendungen',
  'access-time-page.nav-access-time-label-internet': 'Web-Seiten',

  // YouTube Page
  'youtube-page.headline-title': 'YouTube',
  'youtube-page.chart-description': 'YouTube',
  'youtube-page.videos-list': 'Liste der Videos',
  'youtube-page.no-videos': 'Keine Videos zum ausgewählten Datum',
  'youtube-page.block-videoid': 'Dieses Video blockieren',
  'youtube-page.block-channelid': 'Diesen Kanal blockieren',
  'youtube-page.video-blocked': 'Blockiert',

  // Screen Pages
  'screenview-page.headline-title': 'Bildschirmansicht',
  'screenview-page.reload-button': 'Neu laden',
  'screenview-page.chart-description': 'Aktuelle Bildschirmansicht',
  'screengrab-page.headline-title': 'Bildschirm greifen',
  'screengrab-page.chart-description': 'Bildschirmfoto',
  'screengrab-page.screen-save-time': 'Wie oft der Screenshot gemacht wird',
  'screengrab-page.screen-save-time-desc': 'Legen Sie fest, wie oft der Screenshot aufgenommen werden soll, oder wählen Sie "deaktiviert", um keine Screenshots zu machen',
  'screengrab-page.screen-save-time-disabled': 'deaktiviert',
  'screengrab-page.no-screens-for-today': 'An diesem Tag wurden keine Bildschirmfotos aufgenommen',
  'screengrab-page.no-screens-for-filter': 'Keine Bilder, die den ausgewählten Kriterien entsprechen',
  'screengrab-page.imgs-delete-description': 'Sind Sie sicher, dass Sie die ausgewählten Bilder löschen möchten?',
  'screengrab-page.imgs-delete-description-one': 'Sind Sie sicher, dass Sie das ausgewählte Bild löschen möchten?',
  'screengrab-page.imgs-delete-label': 'Löschen',
  'screengrab-page.imgs-delete-select': 'Zum Löschen auswählen',
  'screengrab-page.imgs-delete-selected': 'Ausgewählt:',
  'screengrab-page.imgs-delete-limit': 'Das Limit für die ausgewählten Screenshots wurde erreicht.',
  'screengrab-page.imgs-filter': 'Filtern:',
  'screengrab-page.imgs-filter-communicators': 'Kommunikatoren',
  'screengrab-page.imgs-filter-social': 'Soziale Medien',
  'screengrab-page.imgs-filter-video': 'Video',
  'screengrab-page.imgs-filter-others': 'Andere',

  'screes-pages.device-offline': 'Gerät ist offline',
  'screes-pages.device-deactivated': 'The protection has been temporarily deactivated',
  'screes-pages.device-timeout': 'Gerät hat nicht geantwortet',
  'screes-pages.device-screenoff': 'Der Bildschirm ist ausgeschaltet',
  'screes-pages.device-notallowed': 'Screen Grab ist auf dem Gerät nicht erlaubt',
  'screes-pages.device-error': 'Es ist ein Fehler aufgetreten',

  'lazy-image.img-delete-description': 'Sind Sie sicher, dass Sie das ausgewählte Bild löschen möchten?',

  // Applications Page
  'applications-page.headline-title': 'Anwendungen',
  'applications-page.nav-access-time-label': 'Zugriffszeit',
  'applications-page.nav-statistics-label': 'Zusammenfassung',
  'applications-page.nav-apps-list-label': 'Liste der Anwendungen',
  'applications-page.chart-activity-by-day-label': 'Aktivität während des Tages',
  'applications-page.chart-hour-label': 'Stunde',
  'applications-page.chart-activity-by-hour-minutes-label': 'Aktivität während des Tages in Minuten',
  'applications-page.list-launched-count-label': 'Anzahl der Starts:',
  'applications-page.list-elapsed-time-label': 'Laufende Zeit:',
  'applications-page.introduction': 'Installierte Anwendungen',

  // Applications Page / Settings
  'applications-page.settings.headline-title': 'Zeitbereich einplanen',
  'applications-page.settings.schedule-legend-label': 'Legende zum Zeitplan',
  'applications-page.settings.schedule-blocked-label': 'Gesperrte Apps',
  'applications-page.settings.schedule-available-label': 'Verfügbare Apps',
  'applications-page.time-limit.description': 'Legen Sie ein Zeitlimit für bestimmte Apps fest. Legen Sie fest, wie viele Stunden pro Tag eine Anwendung genutzt werden darf.  ',
  'applications-page.apps-headline-title': 'Verfügbare Apps',
  'applications-page.apps-first-seen-label': 'Zuerst gesehen:',
  'applications-page.apps-available-switch-label': 'Verfügbar',
  'applications-page.apps-not-available-switch-label': 'Nicht verfügbar',
  'applications-page.apps-schedule-switch-label': 'Geplant',
  'applications-page.apps-no-schedule-switch-label': 'Nicht geplant',
  'applications-page.apps-time-limit-switch-label': 'Zeitliche Begrenzung',
  'applications-page.apps-no-time-limit-switch-label': 'Keine zeitliche Begrenzung',
  'applications-page.apps-show-uninstalled-label': 'Deinstallierte Anwendungen anzeigen',
  'applications-page.apps-show-apps-list': 'Zeitlich begrenzte Anwendungen auswählen',

  'applications-page.used-count-zero-label': 'Nicht gestartet',
  'applications-page.used-count-one-label': 'Gestartet {value} Zeit, Gesamtzeit: {totalTime}',
  'applications-page.used-count-many-label': 'Gestartet {Wert} mal, Gesamtzeit: {totalTime}',
  'applications-page.total-hours-minutes-label': '{Stunden} h {Minuten} min',
  'applications-page.total-minutes-seconds-label': '{Minuten} min {Sekunden} sec',
  'applications-page.total-minutes-label': '{Minuten} min',
  'applications-page.total-seconds-label': '{Sekunden} sec',
  'applications-page.total-time-label': 'Gesamtzeit',

  // EmailConfirmationPage
  'email-confirmation-page.bad-code-label': 'Der Aktivierungslink wurde verwendet oder ist ungültig',
  'email-confirmation-page.successful-confirm': 'Die E-Mail wurde bestätigt. Dankeschön!',
  'email-confirmation-page.button-home-page-label': 'OK',

  // Change password
  'change-password-page.change-password-label': 'Passwort ändern',
  'change-password-page.new-password-input-label': 'Neues Passwort',
  'change-password-page.new-password-repeated-input-label': 'Wiederholung des neuen Passworts',
  'change-password-page.current-password-input-label': 'Aktuelles Passwort',
  'change-password-page.back-button-label': 'Zurück',
  'change-password-page.change-button-label': 'ÄNDERN',
  'change-password-page.successful-change-label': 'Das Passwort wurde korrekt geändert',
  'change-password-page.wrong-current-password-label': 'Falsches aktuelles Passwort',
  'change-password-page.password-too-short-label': 'Neues Passwort ist zu kurz',

  // TopNavigation
  'top-navigation.hamburger-menu': 'MENÜ',
  'top-navigation.user-menu.account-label': 'Konto',
  'top-navigation.user-menu.sign-out': 'Abmelden',
  'top-navigation.user-menu.subscription-label': 'Abonnement-Plan',
  'top-navigation.user-menu.change-password-label': 'Passwort ändern',
  'top-navigation.user-menu.add-device-label': 'Gerät hinzufügen',

  // Sidebar
  'sidebar.menu-item.applications': 'Anwendungen',
  'sidebar.menu-item.calls-and-text-messages': 'Anrufe & Texte (SMS)',
  'sidebar.menu-item.internet': 'Web-Seiten',
  'sidebar.menu-item.localizations': 'Lokalisierungen',
  'sidebar.menu-item.social-networks': 'Soziale Netzwerke',
  'sidebar.menu-item.summary': 'Dashboard',
  'sidebar.menu-item.battery': 'Akku',
  'sidebar.menu-item.youtube': 'YouTube',
  'sidebar.menu-item.screenview': 'Bildschirmansicht',
  'sidebar.menu-item.screengrab': 'Bildschirmausschnitt',
  'sidebar.menu-item.access-time': 'Zugang Zeit',

  // Validator
  'phone-number.not-valid': 'Gültige Telefonnummer eingeben',
  'input.required-label': 'Feld ist erforderlich',
  'input.select-required-label': 'Bitte auswählen',
  'email.not-valid-label': 'Gültige E-Mail Adresse eingeben',
  'domain-exist-label': 'Domain wurde hinzugefügt',
  'domain-exist-other-label': 'Domain existiert auf anderer Liste',
  'domain-not-valid': 'Domäne ist nicht gültig',
  'password-not-match-label': 'Passwort stimmt nicht überein',

  // misc
  'button-buy-label': 'Wählen Sie einen Plan',

  'transactiion-status-0': 'Wartet auf',
  'transactiion-status-1': 'Abgeschlossen',
  'transactiion-status--1': 'Abgebrochen',
  'transactiion-status--2': 'Storniert - Erstattung',
  'transactiion-status--3': 'Warten auf Bestätigung',
  'transactiion-status--100': 'Angefangen',
  'transactiion-status-other': 'Andere',

  // reward

  'reward-page.error-ok': 'OK',
  'reward-page.error-success': 'Erfolg',
  'reward-page.error-already-used': 'Dieser Code wurde bereits verwendet',
  'reward-page.error-invalid-code': 'Falscher Code',
  'reward-page.error-connection': 'Verbindungsfehler',
  'reward-page.additional-bonus': 'Bonus',
  'reward-page.get-additional-bonus': 'Aktionsgutschein anfordern',
  'reward-page.get-now': 'Beantragen Sie',
  'reward-page.lic-was-extended-by-days': 'Ihr Abonnementplan wurde um {rewardDays} Tage verlängert!',
  'reward-page.there-was-an-error': 'Leider ist ein Fehler aufgetreten.',
  'reward-page.lic-not-extended': 'Ihr Abonnementplan wurde nicht verlängert.',
  'reward-page.button-close': 'Schließen Sie',

  // url item
  'url-item.copied': 'In die Zwischenablage kopiert',
  'url-item.copy-link': 'Link kopieren',

  // APK howto

  'apk-howto-google-play': 'Der Google Play Store schränkt bestimmte Anwendungsberechtigungen ein, die für die Nutzung dieser Funktion erforderlich sind.',
  'apk-howto-on-the-phone': 'Auf dem Telefon des Kindes mit installierter {applite}',
  'apk-howto-step1': 'Deinstallieren Sie {applite}, wenn Sie es zuvor über Google Play heruntergeladen haben',
  'apk-howto-step2': 'Laden Sie die App direkt über unsere Website auf das Handy des Kindes herunter',
  'apk-howto-step2B': 'oder scannen Sie den unten stehenden QR-Code auf dem Handy des Kindes',
  'apk-howto-step3': 'Heruntergeladene App auf dem Gerät installieren',
  'apk-howto-tutorial': 'Eine Anleitung, wie man die App auf einem Telefon oder Tablet installiert',

  // Cookies

  'cookies-info-uses': 'Diese Website verwendet Cookies.',
  'cookies-info-privacy-policy': 'Mehr dazu in den Datenschutzrichtlinien.',

  // Plan names

  'plan-name-demoExpired': 'Probezeit abgelaufen',
  'plan-name-licExpired': 'Plan abgelaufen',
  'plan-name-reward': 'Bonus',
  'plan-name-demo': 'Testversion',
  'plan-name-minimal': 'Basis',
  'plan-name-regular': 'Regulär',
  'plan-name-premium': 'Premium',

  // agreements

  'agreement-will-inform-user': 'Ich erkläre, dass ich den Nutzer, auf dessen Gerät die App installiert wird, darüber informieren werde, dass seine Aktivitäten und sein Standort überwacht werden.',

  'agreement-privacy-policy': 'Ich erkläre, dass ich die <a href="{Regelungen}" target="_blank">Nutzungsbedingungen</a> und die <a href="{Datenschutz}" target="_blank">Datenschutzbestimmungen</a> gelesen und akzeptiert habe. Ich bestätige, dass ich über 18 Jahre alt bin und meinem Konto nur Kinder hinzufügen werde, die unter 18 Jahre alt sind und von mir gesetzlich abhängig sind.',

  'agreement-marketing': 'I willige ein, von {domain} Marketinginhalte zu Werbeangeboten an die von mir angegebene E-Mail-Adresse und Telefonnummer zu erhalten, sowie die Weiterleitung der Daten an die in der Datenschutzerklärung genannten Werbepartner der Site zum Zwecke der digitalen Werbung. <a href="{marketing}" target="_blank">More</a>',
}

export default {
  locale: 'de-DE',
  name: 'Deutsch',
  data: appLocalData,
  messages
} as LanguageLocale
